export default class Page {
    protected registerComponents() {}

    protected onPageReady() {
        console.log("Page.onPageReady()");
        const loader = document.getElementById('loader');
        if (loader) {
            loader.addEventListener('transitionend', () => loader.remove() );
        }
        document.body.classList.remove('loading');
        document.body.classList.add('loaded');
    }

    public run() {
        this.registerComponents();
    }
}